export default {"src":"/hedera/_next/static/media/chevron_right_light.71b6756b.svg","height":24,"width":24};